<template>
  <div class="template-connected">
    <div id="container">
      <b-modal
        v-model="showMails"
        title="Détails des mails envoyés"
        hide-footer
        size="md"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <history-mail :id="showMailsId"></history-mail>
      </b-modal>
      <div id="title">
        <b-row>
          <b-col class="no-padding">
            <h1>Localisation des demandes</h1>
          </b-col>
          <b-col class="no-padding text-right boite-outils">
            <b-button
              variant="white"
              class="btn-auto"
              @click="mapStatus = !mapStatus"
            >
              <font-awesome-icon icon="map-marked-alt"></font-awesome-icon>
              Afficher / Masquer carte
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div
        :class="
          mapStatus == true
            ? 'block-flat block-flat-map'
            : 'block-flat block-flat-map small'
        "
      >
        <div class="block-content">
          <div id="container-map">
            <maps
              :draw="false"
              :vectorLayers="vectorLayers"
              width="calc(100%)"
            ></maps>
          </div>
        </div>
      </div>
      <div id="content">
        <div class="block-flat">
          <div
            class="filter-demande"
            v-if="
              userConnected.roles.includes('ROLE_ADMIN') ||
                userConnected.roles.includes('ROLE_INSTRUCTEUR')
            "
          >
            <b-row style="display:flex;justify-content:center;">
              <b-col xl="2" md="6" sm="12">
                <b-button
                  variant="light"
                  @click="changeType(1)"
                  :class="myType == 1 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                >
                  <div class="count">{{ foldersNumber[1] }}</div>
                  A traiter
                </b-button>
              </b-col>
              <b-col xl="2" md="6" sm="12">
                <b-button
                  @click="changeType(2)"
                  :class="myType == 2 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                  variant="light"
                >
                  <div class="count">{{ foldersNumber[2] }}</div>
                  En instruction
                </b-button>
              </b-col>
              <b-col xl="2" md="6" sm="12">
                <b-button
                  @click="changeType(3)"
                  :class="myType == 3 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                  variant="light"
                >
                  <div class="count">{{ foldersNumber[3] }}</div>
                  En travaux
                </b-button>
              </b-col>
              <b-col xl="2" md="6" sm="12">
                <b-button
                  @click="changeType(4)"
                  :class="myType == 4 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                  variant="light"
                >
                  <div class="count">{{ foldersNumber[4] }}</div>
                  Demande de réception
                </b-button>
              </b-col>
              <b-col xl="2" md="6" sm="12">
                <b-button
                  @click="changeType(5)"
                  :class="myType == 5 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                  variant="light"
                >
                  <div class="count">{{ foldersNumber[5] }}</div>
                  Réceptionné
                </b-button>
              </b-col>
              <b-col xl="2" md="6" sm="12">
                <b-button
                  @click="changeType(6)"
                  :class="myType == 6 ? 'list active-list' : 'mr-2 list'"
                  size="lg"
                  variant="light"
                >
                  <div class="count">{{ foldersNumber[6] }}</div>
                  Archivé
                </b-button>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="3" class="no-padding">
              <div
                :class="
                  userConnected.roles.includes('ROLE_DEMANDEUR') ||
                  userConnected.roles.includes('ROLE_ADMIN')
                    ? 'd-inline-block icon-container'
                    : 'd-inline-block'
                "
                id="tooltip-legend"
              >
                <font-awesome-icon
                  size="2x"
                  :class="
                    userConnected.roles.includes('ROLE_DEMANDEUR') ||
                    userConnected.roles.includes('ROLE_ADMIN')
                      ? 'text-sudthd pointer icon-info'
                      : 'text-sudthd pointer'
                  "
                  icon="info-circle"
                ></font-awesome-icon>
                <b-tooltip
                  custom-class="tooltip-legend"
                  target="tooltip-legend"
                  triggers="click"
                >
                  <ul class="list-legend">
                    <li v-for="item in states" :key="item.name">
                      <p>
                        <span :class="'status-table statut-' + item.id"></span>
                        {{ item.name }}
                      </p>
                    </li>
                  </ul>
                </b-tooltip>
              </div>
              <b-dropdown
                class="m-md-2"
                variant="success"
                text="Nouvelle demande"
                v-if="
                  userConnected.roles.includes('ROLE_DEMANDEUR') ||
                    userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                    userConnected.roles.includes('ROLE_ADMIN')
                "
              >
                <b-dropdown-item-button @click="goToNewDossier(1)"
                  >Permission de voirie - Réseaux</b-dropdown-item-button
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button @click="goToNewDossier(3)"
                  >Permission de voirie - Accès/Clôture</b-dropdown-item-button
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button @click="goToNewDossier(2)"
                  >Demande d'alignement individuel</b-dropdown-item-button
                >
              </b-dropdown>
              <!-- <b-button variant="success" @click="goToNewDossier()" class="m-md-2"><font-awesome-icon class="mr-1" title="Exporter les demandes"
                  icon="plus"></font-awesome-icon> Nouvelle demande</b-button> -->
              <b-button variant="info" @click="exportData()"
                ><font-awesome-icon
                  class="mr-1"
                  title="Exporter les demandes"
                  icon="download"
                ></font-awesome-icon>
                Export</b-button
              >
            </b-col>

            <b-col
              class="no-padding text-right boite-outils"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="9"
              style="padding-top: 10px !important"
            >
              <b-form-select
                class="num-pagination"
                v-model="paginationSelected.numItemsPerPage"
                :options="NumberItems"
              ></b-form-select>

              <div class="input-search">
                <div class="datepicker-trigger">
                  <input
                    type="text"
                    class="form-control"
                    id="datepicker-trigger"
                    placeholder="Filtrer par date de début des travaux"
                    :value="formatDates(dateStartTvx, dateEndTvx)"
                  />

                  <AirbnbStyleDatepicker
                    @apply="applyDateRange()"
                    @cancelled="clearDate(true)"
                    @closed="clearDate(false)"
                    :trigger-element-id="'datepicker-trigger'"
                    :mode="'range'"
                    :fullscreen-mobile="true"
                    :date-one="dateStartTvx"
                    :date-two="dateEndTvx"
                    @date-one-selected="
                      (val) => {
                        dateStartTvx = val;
                      }
                    "
                    @date-two-selected="
                      (val) => {
                        dateEndTvx = val;
                      }
                    "
                  />
                </div>
              </div>

              <div class="input-search">
                <b-form-input
                  @keyup.enter="runSearch()"
                  v-model="searchText"
                  class="form-control"
                  placeholder="Recherche"
                />
              </div>
              <b-button
                @click="runSearch()"
                variant="success"
                block
                class="btn-auto mr-2 search-liste"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="search"
                ></font-awesome-icon>
                <span>Rechercher</span>
              </b-button>
              <b-button
                @click="clearSearch()"
                variant="danger"
                block
                class="btn-auto mr-2 search-liste"
              >
                <font-awesome-icon icon="times"></font-awesome-icon>
              </b-button>
            </b-col>
          </b-row>

          <div class="listing-demandes">
            <div
              v-if="
                !userConnected.roles.includes('ROLE_ADMIN') ||
                  !userConnected.roles.includes('ROLE_INSTRUCTEUR')
              "
            >
              <table class="table-demandes">
                <header-grid
                  :searchSort="searchSort"
                  @change="applyFilter($event)"
                  :headers="headersAdmin"
                  v-if="
                    userConnected.roles.includes('ROLE_ADMIN') ||
                      userConnected.roles.includes('ROLE_INSTRUCTEUR')
                  "
                ></header-grid>
                <header-grid
                  :searchSort="searchSort"
                  @change="applyFilter($event)"
                  :headers="headers"
                  v-else
                ></header-grid>
                <tbody v-if="dossiers.length > 0">
                  <tr v-for="dossier in dossiers" :key="dossier.id">
                    <td class="text-center link-detail">
                      <b>{{ dossier.id }}</b>
                      <div class="hover-thumb" @click="goToDossier(dossier)">
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </div>
                    </td>
                    <td class="text-center td-type">
                      <span
                        v-if="
                          dossier.cerfa1402301 != null &&
                            dossier.alignement == null
                        "
                      >
                        <span v-if="dossier.isAccessDevelopment == true">
                          <font-awesome-icon
                            :id="'tooltip-type-' + dossier.id"
                            icon="archway"
                          ></font-awesome-icon>
                          <b-tooltip
                            :target="'tooltip-type-' + dossier.id"
                            triggers="hover"
                          >
                            Permission de voirie - Accès/Clôture
                          </b-tooltip>
                        </span>
                        <span v-else>
                          <font-awesome-icon
                            :id="'tooltip-type-' + dossier.id"
                            icon="road"
                          ></font-awesome-icon>
                          <b-tooltip
                            :target="'tooltip-type-' + dossier.id"
                            triggers="hover"
                          >
                            Permission de voirie - Réseaux
                          </b-tooltip>
                        </span>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 == null &&
                            dossier.alignement != null
                        "
                      >
                        <font-awesome-icon
                          :class="''"
                          :id="'tooltip-type-' + dossier.id"
                          icon="ruler-combined"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Demande d'alignement individuel
                        </b-tooltip>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 == null &&
                            dossier.alignement == null
                        "
                      >
                        <font-awesome-icon
                          :id="'tooltip-type-' + dossier.id"
                          icon="question-circle"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Pas de type
                        </b-tooltip>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 != null &&
                            dossier.alignement != null &&
                            dossier.isAccessDevelopment == false
                        "
                      >
                        <font-awesome-icon
                          :class="''"
                          :id="'tooltip-type-' + dossier.id"
                          icon="ruler-combined"
                        ></font-awesome-icon>
                        <font-awesome-icon
                          :id="'tooltip-type-' + dossier.id"
                          icon="road"
                          class="ml-2"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Permission de voirie - Réseaux et Demande d'alignement
                        </b-tooltip>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 != null &&
                            dossier.alignement != null &&
                            dossier.isAccessDevelopment == true
                        "
                      >
                        <font-awesome-icon
                          :class="''"
                          :id="'tooltip-type-' + dossier.id"
                          icon="ruler-combined"
                        ></font-awesome-icon>
                        <font-awesome-icon
                          :id="'tooltip-type-' + dossier.id"
                          icon="archway"
                          class="ml-2"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Permission de voirie - Accès/Clôture et Demande
                          d'alignement
                        </b-tooltip>
                      </span>
                    </td>
                    <td class="text-center td-statut">
                      <font-awesome-icon
                        v-if="
                          dossier.state_id == 3 && dossier.sendToSign == true
                        "
                        icon="signature"
                        style="margin-right: 8px"
                      ></font-awesome-icon>
                      <span
                        :id="'tooltip-state-' + dossier.id"
                        :class="'status-table statut-' + dossier.state_id"
                      ></span>
                      <b-tooltip
                        v-if="dossier.sendToSign != true"
                        :target="'tooltip-state-' + dossier.id"
                        triggers="hover"
                      >
                        {{ dossier.state_name }}
                      </b-tooltip>
                      <b-tooltip
                        v-if="dossier.sendToSign == true"
                        :target="'tooltip-state-' + dossier.id"
                        triggers="hover"
                      >
                        {{ dossier.state_name }}
                        <span v-if="dossier.state_id != 2">
                          Dossier envoyé en signature. En attente de retour
                        </span>
                      </b-tooltip>
                    </td>
                    <td
                      class="text-center td-instructeur"
                      v-if="
                        userConnected.roles.includes('ROLE_ADMIN') ||
                          userConnected.roles.includes('ROLE_INSTRUCTEUR')
                      "
                    >
                      <b
                        v-if="
                          (dossier.state_id == 3 &&
                            dossier.sendToSign == true &&
                            dossier.instructeurId != null) ||
                            (dossier.state_id >= 3 &&
                              dossier.instructeurId != null)
                        "
                        >{{ getInitials(dossier.instructeurFirstName) }}.{{
                          getInitials(dossier.instructeurLastName)
                        }}</b
                      >
                      <!-- <b v-else> </b> -->
                    </td>
                    <!-- icn-double-line -->
                    <td class="td-localisation">
                      <font-awesome-icon
                        icon="map-marker-alt"
                      ></font-awesome-icon>
                      {{ dossier.addressNum }} {{ dossier.addressType }}
                      {{ dossier.addressName }}
                    </td>
                    <td class="td-demandeur">
                      <span
                        v-if="dossier.demandeurPrenom && dossier.demandeurNom"
                      >
                        {{ dossier.demandeurPrenom }} {{ dossier.demandeurNom }}
                      </span>
                      <span v-if="dossier.demandeurCorporation">
                        "{{ dossier.demandeurCorporation }}" -
                        {{ dossier.demandeurCorporationAgent }}
                      </span>
                    </td>
                    <td class="td-numaffaire">
                      <font-awesome-icon
                        v-if="dossier.numaffaire"
                        icon="briefcase"
                      ></font-awesome-icon>
                      {{ dossier.numaffaire }}
                    </td>
                    <td class="td-ville">
                      {{ dossier.addressCity }}
                    </td>
                    <td class="td-depot">
                      <font-awesome-icon
                        :icon="['far', 'clock']"
                      ></font-awesome-icon>
                      {{ dossier.depositDate }}
                    </td>
                    <td class="td-debut">
                      <font-awesome-icon
                        v-if="dossier.dateStart != null"
                        icon="wrench"
                      ></font-awesome-icon>
                      {{ dossier.dateStart }}<br />
                    </td>
                    <td class="text-center lst-actions">
                      <b-button
                        @click="goToDossier(dossier)"
                        v-b-tooltip.hover
                        title="Ouvrir la demande"
                        variant="secondary"
                        class="mr-2"
                      >
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </b-button>
                      <b-button
                        @click="locate(dossier)"
                        v-b-tooltip.hover
                        title="Localiser la demande"
                        variant="warning"
                        class="mr-2"
                        v-if="dossier.state_id !== 1"
                      >
                        <font-awesome-icon
                          @click="locate(dossier)"
                          icon="map-marker-alt"
                        ></font-awesome-icon>
                      </b-button>
                      <b-button
                        v-if="
                          myType != 3 &&
                            ((dossier.state_id == 3 &&
                              userConnected.roles.includes('ROLE_DEMANDEUR')) ||
                              (dossier.state_id !== 1 &&
                                dossier.state_id !== 10 &&
                                dossier.state_id !== 2 &&
                                (userConnected.roles.includes('ROLE_ADMIN') ||
                                  userConnected.roles.includes(
                                    'ROLE_INSTRUCTEUR'
                                  ))))
                        "
                        @click="deleteFolder(dossier)"
                        v-b-tooltip.hover
                        title="Annuler la demande"
                        variant="danger"
                        class="mr-2"
                      >
                        <font-awesome-icon
                          @click="locate(dossier)"
                          icon="times"
                        ></font-awesome-icon>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <table class="table-demandes">
                <header-grid
                  :searchSort="searchSort"
                  @change="applyFilter($event)"
                  :headers="headersAdmin"
                  v-if="
                    userConnected.roles.includes('ROLE_ADMIN') ||
                      userConnected.roles.includes('ROLE_INSTRUCTEUR')
                  "
                ></header-grid>
                <header-grid
                  :searchSort="searchSort"
                  @change="applyFilter($event)"
                  :headers="headers"
                  v-else
                ></header-grid>
                <tbody v-if="dossiers.length > 0">
                  <tr v-for="dossier in dossiers" :key="dossier.id">
                    <td class="text-center link-detail">
                      <b>{{ dossier.id }}</b>
                      <div class="hover-thumb" @click="goToDossier(dossier)">
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </div>
                    </td>
                    <td class="text-center td-type">
                      <span
                        v-if="
                          dossier.cerfa1402301 != null &&
                            dossier.alignement == null
                        "
                      >
                        <span v-if="dossier.isAccessDevelopment == true">
                          <font-awesome-icon
                            :id="'tooltip-type-' + dossier.id"
                            icon="archway"
                          ></font-awesome-icon>
                          <b-tooltip
                            :target="'tooltip-type-' + dossier.id"
                            triggers="hover"
                          >
                            Permission de voirie - Accès/Clôture
                          </b-tooltip>
                        </span>
                        <span v-else>
                          <font-awesome-icon
                            :id="'tooltip-type-' + dossier.id"
                            icon="road"
                          ></font-awesome-icon>
                          <b-tooltip
                            :target="'tooltip-type-' + dossier.id"
                            triggers="hover"
                          >
                            Permission de voirie - Réseaux
                          </b-tooltip>
                        </span>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 == null &&
                            dossier.alignement != null
                        "
                      >
                        <font-awesome-icon
                          :class="''"
                          :id="'tooltip-type-' + dossier.id"
                          icon="ruler-combined"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Demande d'alignement individuel
                        </b-tooltip>
                      </span>
                      <span
                        v-if="
                          dossier.cerfa1402301 == null &&
                            dossier.alignement == null
                        "
                      >
                        <font-awesome-icon
                          :id="'tooltip-type-' + dossier.id"
                          icon="question-circle"
                        ></font-awesome-icon>
                        <b-tooltip
                          :target="'tooltip-type-' + dossier.id"
                          triggers="hover"
                        >
                          Pas de type
                        </b-tooltip>
                      </span>
                    </td>
                    <td class="text-center td-statut">
                      <font-awesome-icon
                        v-if="
                          dossier.state_id == 3 && dossier.sendToSign == true
                        "
                        icon="signature"
                        style="margin-right: 8px"
                      ></font-awesome-icon>
                      <span
                        :id="'tooltip-state-' + dossier.id"
                        :class="'status-table statut-' + dossier.state_id"
                      ></span>
                      <b-tooltip
                        v-if="dossier.sendToSign != true"
                        :target="'tooltip-state-' + dossier.id"
                        triggers="hover"
                      >
                        {{ dossier.state_name }}
                      </b-tooltip>
                      <b-tooltip
                        v-if="dossier.sendToSign == true"
                        :target="'tooltip-state-' + dossier.id"
                        triggers="hover"
                      >
                        {{ dossier.state_name }}
                        Dossier envoyé en signature. En attente de retour
                      </b-tooltip>
                    </td>
                    <td
                      class="text-center td-instructeur"
                      v-if="
                        userConnected.roles.includes('ROLE_ADMIN') ||
                          userConnected.roles.includes('ROLE_INSTRUCTEUR')
                      "
                    >
                      <b
                        v-if="
                          (dossier.state_id == 3 &&
                            dossier.sendToSign == true &&
                            dossier.instructeurId != null) ||
                            (dossier.state_id > 3 &&
                              dossier.instructeurId != null)
                        "
                        >{{ getInitials(dossier.instructeurFirstName) }}.{{
                          getInitials(dossier.instructeurLastName)
                        }}</b
                      >
                      <b v-else>Inconnu</b>
                    </td>
                    <!-- icn-double-line -->
                    <td class="td-localisation">
                      <font-awesome-icon
                        icon="map-marker-alt"
                      ></font-awesome-icon>
                      {{ dossier.addressNum }} {{ dossier.addressType }}
                      {{ dossier.addressName }}
                    </td>
                    <td class="td-demandeur">
                      <span
                        v-if="dossier.demandeurPrenom && dossier.demandeurNom"
                      >
                        {{ dossier.demandeurPrenom }} {{ dossier.demandeurNom }}
                      </span>
                      <span v-if="dossier.demandeurCorporation">
                        "{{ dossier.demandeurCorporation }}" -
                        {{ dossier.demandeurCorporationAgent }}
                      </span>
                    </td>
                    <td class="td-numaffaire">
                      <font-awesome-icon
                        v-if="dossier.numaffaire"
                        icon="briefcase"
                      ></font-awesome-icon>
                      {{ dossier.numaffaire }}
                    </td>
                    <td class="td-ville">
                      {{ dossier.addressCity }}
                    </td>
                    <td class="td-depot">
                      <font-awesome-icon
                        :icon="['far', 'clock']"
                      ></font-awesome-icon>
                      {{ dossier.depositDate }}
                    </td>
                    <td class="td-debut">
                      <font-awesome-icon
                        v-if="dossier.dateStart != null"
                        icon="wrench"
                      ></font-awesome-icon>
                      {{ dossier.dateStart }}<br />
                    </td>
                    <td class="text-center lst-actions">
                      <b-button
                        @click="goToDossier(dossier)"
                        v-b-tooltip.hover
                        title="Ouvrir la demande"
                        variant="secondary"
                        class="mr-2"
                      >
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </b-button>
                      <b-button
                        @click="locate(dossier)"
                        v-b-tooltip.hover
                        title="Localiser la demande"
                        variant="warning"
                        class="mr-2"
                        v-if="dossier.state_id !== 1"
                      >
                        <font-awesome-icon
                          @click="locate(dossier)"
                          icon="map-marker-alt"
                        ></font-awesome-icon>
                      </b-button>
                      <b-button
                        v-if="
                          dossier.state_id == 3 &&
                            userConnected.roles.includes('ROLE_DEMANDEUR')
                        "
                        @click="deleteFolder(dossier)"
                        v-b-tooltip.hover
                        title="Annuler la demande"
                        variant="danger"
                        class="mr-2"
                      >
                        <font-awesome-icon
                          @click="locate(dossier)"
                          icon="times"
                        ></font-awesome-icon>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <b-row class="listing-demandes">
            <b-col cols="12" class="no-padding">
              <div class="pagination" v-if="paginationSelected">
                <b-pagination
                  v-model="paginationSelected.current"
                  :total-rows="paginationSelected.totalCount"
                  :per-page="paginationSelected.numItemsPerPage"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../router/index";
import maps from "../components/Maps.vue";
import headergrid from "../components/HeaderGrid.vue";
import Vuex from "vuex";
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox,
} from "vuelayers/lib/ol-ext";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Point from "ol/geom/Point";
import { addDays, format } from "date-fns";
import historyMails from "../components/historyMails.vue";

const STORAGE_KEY = 'listingSearchParams';

export default {
  watch: {
    mapStatus: {
      handler: function(val) {
        if (val == true) {
          this.$nextTick(() => {
            if (window.Event) {
              window.Event.$emit("refreshMap");
            }
          });
        }
      },
    },
    "paginationSelected.current": function() {
      this.runSearch();
    },
    "paginationSelected.numItemsPerPage": function() {
      if (this.paginationSelected.current != 1) {
        this.paginationSelected.current = 1;
      } else {
        this.runSearch();
      }
      this.saveSearchParams();
    },
    searchText(newVal) {
        this.saveSearchParams();
    },
  },
  async mounted() {
    this.loadSearchParams();

    this.headers.find(
      (element) => element.name == "statut"
    ).filterData = await this.countDossiers();
    if (
      this.userConnected.roles.includes("ROLE_ADMIN") ||
      this.userConnected.roles.includes("ROLE_INSTRUCTEUR")
    ) {
      if (!this.myType) {  // si myType non chargé depuis storage
        this.myType = 1;
      }
      await this.getStates(this.myType);
    } else {
      await this.getStates();
    }
    this.runSearch();
    this.updateFilterData();
  },
  name: "Listing",
  data: () => ({
    dateStartTvx: null,
    dateEndTvx: null,
    mapStatus: true,
    myType: '',
    showMails: false,
    NumberItems: ["50", "100", "150", "200", "250"],
    showMailsId: null,
    headers: [
      {
        name: "id",
        code: "r.id",
        width: "70px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "type",
        code: "type",
        width: "70px",
        open: false,
        sortable: false,
        filterable: true,
        dir: null,
        filter: null,
        filterData: [
          {
            id: "r.cerfa14023_01_id",
            name: "Permission de voirie - Réseaux",
          },
          {
            id: "amenagementAccess",
            name: "Permission de voirie - Accès/Clôture",
          },
          {
            id: "r.individualalignmentrequest_id",
            name: "Demande d'alignement",
          },
        ],
      },
      {
        name: "statut",
        code: "r.state_id",
        width: "80px",
        open: false,
        sortable: false,
        filterable: true,
        dir: null,
        filter: null,
        filterData: [],
      },
      {
        name: "localisation",
        code: "r.address_name",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "demandeur",
        code: "peti.corporation_name",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Numéro affaire",
        code: "r.numaffaire",
        width: "180px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "ville",
        code: "r.address_city",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "dépôt",
        code: "r.deposit_date",
        width: "120px",
        open: false,
        sortable: true,
        filterable: false,
        dir: "DESC",
        filter: null,
        filterData: null,
      },
      {
        name: "début",
        code: "r.date_start",
        width: "120px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "actions",
        width: "215px",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
    ],
    headersAdmin: [
      {
        name: "id",
        code: "r.id",
        width: "70px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "type",
        code: "type",
        width: "70px",
        open: false,
        sortable: false,
        filterable: true,
        dir: null,
        filter: null,
        filterData: [
          {
            id: "r.cerfa14023_01_id",
            name: "Permission de voirie - Réseaux",
          },
          {
            id: "amenagementAccess",
            name: "Permission de voirie - Accès/Clôture",
          },
          {
            id: "r.individualalignmentrequest_id",
            name: "Demande d'alignement",
          },
        ],
      },
      {
        name: "statut",
        code: "r.state_id",
        width: "80px",
        open: false,
        sortable: false,
        filterable: true,
        dir: null,
        filter: null,
        filterData: [],
      },
      {
        name: "Instructeur",
        code: "r.instructeur_id",
        width: "60px",
        open: false,
        sortable: false,
        filterable: true,
        dir: null,
        filter: null,
        filterData: [
          {
            id: 7,
            name: "Mégane Allegre",
          },
          {
            id: 350,
            name: "Pierre-Albert Anselm",
          },
          {
            id: 23,
            name: "Pierre Moens",
          },
          {
            id: 13,
            name: "Remi Morel",
          },
          {
            id: 233,
            name: "Vincent Nugnes",
          },
          {
            id: 410,
            name: "Audrey Pokutycki",
          },
          {
            id: 22,
            name: "Claire Sengel",
          },
        ],
      },
      {
        name: "localisation",
        code: "r.address_name",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "demandeur",
        code: "peti.corporation_name",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Numéro affaire",
        code: "r.numaffaire",
        width: "180px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "ville",
        code: "r.address_city",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "dépôt",
        code: "r.deposit_date",
        width: "120px",
        open: false,
        sortable: true,
        filterable: false,
        dir: "DESC",
        filter: null,
        filterData: null,
      },
      {
        name: "début",
        code: "r.date_start",
        width: "120px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "actions",
        width: "200px",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
    ],
    searchText: "",
    searchFilter: {},
    searchSort: "r.deposit_date",
    searchDir: "DESC",
    dateFormat: "DD/MM/YYYY",
  }),
  components: {
    "history-mail": historyMails,
    maps: maps,
    "header-grid": headergrid,
  },
  methods: {
    saveSearchParams() {
      const params = {
        type: this.myType,
        numItemsPerPage: this.paginationSelected?.numItemsPerPage,
        searchText: this.searchText,
        searchSort: this.searchSort,
        searchDir: this.searchDir,
        searchFilter: this.searchFilter,
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    },

    loadSearchParams() {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        try {
          const params = JSON.parse(saved);
          if (params.type !== undefined) this.myType = params.type;
          if (params.numItemsPerPage !== undefined) {
            this.pagination.numItemsPerPage = parseInt(params.numItemsPerPage, 10);
          }
          if (params.searchText !== undefined) this.searchText = params.searchText;
          if (params.searchSort !== undefined) this.searchSort = params.searchSort;
          if (params.searchDir !== undefined) this.searchDir = params.searchDir;
          if (params.searchFilter !== undefined) this.searchFilter = params.searchFilter;

          const applySortDir = (headers) => {
            headers.forEach((header) => {
              if (header.code === this.searchSort) {
                header.dir = this.searchDir;
              } else {
                header.dir = null;
              }
            });
          };
          applySortDir(this.headers);
          applySortDir(this.headersAdmin);

        } catch(e) {
          console.error("Erreur lors du parsing des paramètres du sessionStorage", e);
        }
      }
    },
    updateFilterData() {
      const filterData = this.states.map(state => ({
        id: state.id,
        name: state.name
      }));

      // Mettez à jour les filterData pour headers et headersAdmin
      const statutHeader = this.headers.find(header => header.name === 'statut');
      if (statutHeader) {
        statutHeader.filterData = filterData;
      }

      const statutHeaderAdmin = this.headersAdmin.find(header => header.name === 'statut');
      if (statutHeaderAdmin) {
        statutHeaderAdmin.filterData = filterData;
      }
    },
    exportData() {
      let param = "";
      const options = { method: "GET" };

      if (
        this.userConnected.roles.includes("ROLE_ADMIN") ||
        this.userConnected.roles.includes("ROLE_INSTRUCTEUR")
      ) {
        param = "export/admin";
      } else {
        param = "export";
      }

      (param +=
        "?type=" +
        this.myType +
        "&searchText=" +
        this.searchText +
        "&searchFilter=" +
        JSON.stringify(this.searchFilter) +
        "&searchSort=" +
        this.searchSort),
        +"&searchDir=" + this.searchDir;

      var myHeaders = new Headers({
        Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
      });

      fetch(window.urlapi + param, {
        method: "GET",
        headers: myHeaders,
        // body: JSON.stringify({ dep: dep, geom: geom }),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Export.csv");
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getInitials(name) {
      if (name) {
        const words = name.split(" ");
        const initials = words.map((word) => word.charAt(0)).join("");
        return initials;
      }
      return "";
    },
    async changeType(type) {
      this.currentPage = 1;
      this.myType = type;
      delete this.searchFilter["r.state_id"];
      this.saveSearchParams();
      await this.runSearch();
      await this.getStates(type);
      this.updateFilterData();
    },
    showHistory(id) {
      this.showMailsId = id;
      this.showMails = true;
    },
    clearDate(force) {
      if (force) {
        this.dateStartTvx = null;
        this.dateEndTvx = null;
        this.runSearch();
      } else {
        if (
          !this.searchFilter["date_start1"] &&
          !this.searchFilter["date_start2"]
        ) {
          this.dateStartTvx = null;
          this.dateEndTvx = null;
        }
      }
    },
    applyDateRange() {
      this.searchFilter["date_start1"] = this.dateStartTvx;
      this.searchFilter["date_start2"] = this.dateEndTvx;
      this.saveSearchParams();
      this.runSearch();
    },
    deleteFolder(dossier) {
      dossier.state_id = 1;
      dossier.stateId = 1;
      if (!dossier.madeDate && dossier.made_date) {
        dossier.madeDate = dossier.made_date;
      }
      this.updateDossier(dossier);
      Vue.prototype.$awn.success("Demande annulée");
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    goToNewDossier(choice) {
      router.push({ name: "ajoutdossier", params: { choixForm: choice } });
    },
    applyFilter(header) {
      this.headers.forEach((element) => {
        if (element.name != header.name) {
          element.dir = "";
        } else {
          element.open = false;
        }
      });

      if (header.filter && header.filter != null && header.filter != "") {
        this.searchFilter[header.code] = header.filter;
      }
      if (header.dir && header.dir != "" && header.dir != null) {
        this.searchSort = header.code;
        this.searchDir = header.dir;
      }

      this.saveSearchParams();
      this.runSearch();
    },
    clearSearch() {
      this.myType = 1;
      this.searchText = "";
      this.dateStartTvx = null;
      this.dateEndTvx = null;
      this.searchFilter = {};
      this.searchSort = "r.deposit_date";
      this.searchDir = "DESC";
      this.headers.forEach((element) => {
        if (element.code == this.searchSort) {
          element.dir = this.searchDir;
        }
      });
      this.saveSearchParams();
      this.runSearch();
    },
    async runSearch() {
      let page =
        this.paginationSelected && this.paginationSelected.current
          ? this.paginationSelected.current
          : 1;

      await this.getDossiers({
        page: page,
        type: this.myType,
        numItemsPerPage: this.paginationSelected.numItemsPerPage,
        searchText: this.searchText,
        searchSort: this.searchSort,
        searchDir: this.searchDir,
        searchFilter: this.searchFilter,
      });

      await this.countDossiers({
        type: this.myType,
        searchText: this.searchText,
        searchFilter: this.searchFilter,
      });
    },

    goToDossier(dossier) {
      let encrypted = this.$aes.encrypt(dossier.id.toString());
      const routeData = router.resolve({ name: "Dossier", params: { id: encrypted } });
      window.open(routeData.href, '_blank');
    },
    locate(dossier) {
      window.Event.$emit("locatePoint", dossier);
    },
    ...Vuex.mapActions("Map", ["showBaseLayer"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossiers",
      "addDossier",
      "updateDossier",
      "countDossiers",
    ]),
    ...Vuex.mapActions("State", ["getStates"]),
  },
  computed: {
    paginationSelected: {
      get() {
        return this.pagination;
      },
      set(value) {
        this.setPagination(value);
      },
    },
    vectorLayers: function() {
      let me = this;
      let tab = [];
      if (typeof this.features !== "undefined") {
        tab.push({
          vectorZIndex: 100,
          ref: "DossierPointLayer",
          visible: true,
          select: true,
          features: this.features,
          factory: function() {
            return (feature) => {
              if (feature.getProperties().marker) {
                return [
                  new Style({
                    zIndex: 150,
                    image: new Icon({
                      src: require("../img/marker-map/" +
                        (feature.getProperties().marker || "demande.png")),
                      scale: 0.5,
                    }),
                  }),
                ];
              } else {
                return [];
              }
            };
          },
          click: function(id) {
            let encrypted = me.$aes.encrypt(id.toString());
            router.push({ name: "Dossier", params: { id: encrypted } });
          },
        });
      }

      return tab;
    },

    ...Vuex.mapGetters("Dossiers", [
      "dossiers",
      "pagination",
      "features",
      "dossierSelected",
      "foldersNumber",
    ]),

    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("State", ["states"]),
  },
};
</script>
